import moment from 'moment';

class ImportMapper {
  static csvPayload(_ref) {
    let {
      url,
      source
    } = _ref;
    return {
      upload_url: url,
      source
    };
  }
  static triggerFiveDayImportFromIntegrationPayload(_ref2) {
    let {
      date,
      source
    } = _ref2;
    const dateFormat = 'YYYY-MM-DD';
    const now = moment(date);
    const to = now.format(dateFormat);
    const from = now.subtract(5, 'days').format(dateFormat);
    return {
      IMPORT_FROM: from,
      IMPORT_TO: to,
      callback_payload: source
    };
  }
  static createGetUrlModelFromResponse(data) {
    return {
      downloadUrl: data.download_url,
      uploadUrl: data.upload_url
    };
  }
}

export { ImportMapper };
//# sourceMappingURL=ImportMapper.js.map
